export const SITE_URL = "https://atlantaluxurysprinters.com";
export const BUSINESS_ID = `${SITE_URL}/#business`;

export function buildBreadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function ldScript(data: unknown) {
  return { type: "application/ld+json", children: JSON.stringify(data) };
}

/** Standard head() for a new static page: title, description, canonical, OG, Twitter. */
export function pageHead({
  path,
  title,
  description,
  ogType = "website",
  scripts = [],
  links = [],
}: {
  path: string;
  title: string;
  description: string;
  ogType?: string;
  scripts?: { type: string; children: string }[];
  links?: { rel: string; href: string; hrefLang?: string }[];
}) {
  const url = `${SITE_URL}${path}`;
  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: ogType },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: url }, ...links],
    scripts,
  };
}
